import z from "zod";
import type { Context } from "hono";

export const duplicateProjectRequestBodySchema = z.object({
  projectId: z.string(),
});

export type DuplicateProjectRequestBody = z.infer<
  typeof duplicateProjectRequestBodySchema
>;

export type DuplicateProjectResponseBody = {
  newProjectId: string;
};

export type DuplicateProjectHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      | DuplicateProjectResponseBody
      | { error: string }
      | { errors: z.ZodIssue[] }
      | string
    >
  >
>;
